export const sponsorsHelpLink = "https://ecoa.veevavault.help/en/gr/"
